import { Endpoint } from '../endpoint';

export const ReferenceListDependency = new Endpoint('reference_list_dependency');
